import { str_replace } from './helper_string';
export function removeBraces(t) {
    let s = t;
    s = s.replace(/ {[^{}]+}/, '');
    s = s.replace(/{[^{}]+} /, '');
    s = s.replace(/{[^{}]+}/, '');
    return s;
}
export function removeBrackets(t) {
    let s = t;
    s = s.replace(/ \[[^\[\]]+\]/, '');
    s = s.replace(/\[[^\[\]]+\] /, '');
    s = s.replace(/\[[^\[\]]+\]/, '');
    return s;
}
export function removeParenthesis(t) {
    let s = t;
    s = s.replace(/ \([^\(\)]+\)/, '');
    s = s.replace(/\([^\(\)]+\) /, '');
    s = s.replace(/\([^\(\)]+\)/, '');
    return s;
}
export function removeAnnotations(t) {
    let s = t;
    s = removeParenthesis(s);
    s = removeBrackets(s);
    s = removeBraces(s);
    return s;
}
export function vocabulary_cleanstring(t) {
    let s = t;
    s = str_replace('jemanden', 'jdn', s);
    s = str_replace(['´', '`', '’'], "'", s);
    s = str_replace('jemandem', 'jdm', s);
    s = str_replace('etwas', 'etw', s);
    s = str_replace('jemand', 'jd', s);
    s = str_replace('somebody', 'sb', s);
    s = str_replace('something', 'sth', s);
    s = str_replace('quelque chose', 'qc', s);
    s = str_replace("quelqu'un", 'qn', s);
    s = str_replace('someone', 'sb', s);
    s = str_replace('so.', 'sb', s);
    s = helper_capitaliseFirstLetter(s);
    s = str_replace(['.', '.', '?', '      ', '     ', '    ', '   ', '  '], ' ', s);
    return s.trim();
}
/*
export function flattenParanthesisRecursive(array, string) {
  let text = '';
  let flattened = str_replace('(', '', string);
  flattened = str_replace(')', '', flattened);
  // @ts-ignore
  if ($.inArray(flattened, array) === -1) array.push($.trim(flattened));
  // @ts-ignore
  let pms = /\([^\(\)]+\)/g.execAll(string);

  for (let i = 0; i < pms.length; i = i + 1) {
    text = str_replace(pms[i], '', string);
    text = str_replace('    ', ' ', text);
    text = str_replace('   ', ' ', text);
    text = str_replace('  ', ' ', text);

    if (text.match(/\([^\(\)]+\)/g)) {
      // @ts-ignore
      array = flattenParanthesisRecursive(array, text);
    } else {
      // @ts-ignore
      if ($.inArray($.trim(text), array) === -1) {
        array.push($.trim(text));
      }
    }
  }
  return array;
}
*/
function similar_text_raw(first, second) {
    // Calculates the similarity between two strings
    //
    // version: 1109.2015
    // discuss at: http://phpjs.org/functions/similar_text
    // +   original by: Rafał Kukawski (http://blog.kukawski.pl)
    // +   bugfixed by: Chris McMacken
    // *     example 1: similar_text('Hello World!', 'Hello phpjs!');
    // *     returns 1: 7
    // *     example 2: similar_text('Hello World!', null);
    // *     returns 2: 0
    if (first === null || second === null || typeof first === 'undefined' || typeof second === 'undefined') {
        return 0;
    }
    first += '';
    second += '';
    let pos1 = 0, pos2 = 0, max = 0, firstLength = first.length, secondLength = second.length, p, q, l, sum;
    max = 0;
    for (p = 0; p < firstLength; p++) {
        for (q = 0; q < secondLength; q++) {
            for (l = 0; p + l < firstLength && q + l < secondLength && first.charAt(p + l) === second.charAt(q + l); l++)
                ;
            if (l > max) {
                max = l;
                pos1 = p;
                pos2 = q;
            }
        }
    }
    sum = max;
    if (sum) {
        if (pos1 && pos2) {
            sum += similar_text_raw(first.substr(0, pos2), second.substr(0, pos2));
        }
        if (pos1 + max < firstLength && pos2 + max < secondLength) {
            sum += similar_text_raw(first.substr(pos1 + max, firstLength - pos1 - max), second.substr(pos2 + max, secondLength - pos2 - max));
        }
    }
    return sum;
}
export function similar_text(first, second) {
    return Math.round((100 * similar_text_raw(first, second)) / Math.max(first.length, second.length));
}
export function similar_levenshtein(first, second) {
    return 100 - Math.round((100 * levenshtein(first, second)) / Math.max(first.length, second.length));
}
export function levenshtein(s1, s2) {
    // Calculate Levenshtein distance between two strings
    //
    // version: 1109.2015
    // discuss at: http://phpjs.org/functions/levenshtein
    // +            original by: Carlos R. L. Rodrigues (http://www.jsfromhell.com)
    // +            bugfixed by: Onno Marsman
    // +             revised by: Andrea Giammarchi (http://webreflection.blogspot.com)
    // + reimplemented by: Brett Zamir (http://brett-zamir.me)
    // + reimplemented by: Alexander M Beedie
    // *                example 1: levenshtein('Kevin van Zonneveld', 'Kevin van Sommeveld');
    // *                returns 1: 3
    if (s1 == s2) {
        return 0;
    }
    let s1_len = s1.length;
    let s2_len = s2.length;
    if (s1_len === 0) {
        return s2_len;
    }
    if (s2_len === 0) {
        return s1_len;
    }
    // BEGIN STATIC
    let split = false;
    try {
        split = !'0'[0];
    }
    catch (e) {
        split = true; // Earlier IE may not support access by string index
    }
    // END STATIC
    if (split) {
        s1 = s1.split('');
        s2 = s2.split('');
    }
    let v0 = new Array(s1_len + 1);
    let v1 = new Array(s1_len + 1);
    let s1_idx = 0, s2_idx = 0, cost = 0;
    for (s1_idx = 0; s1_idx < s1_len + 1; s1_idx++) {
        v0[s1_idx] = s1_idx;
    }
    let char_s1 = '', char_s2 = '';
    for (s2_idx = 1; s2_idx <= s2_len; s2_idx++) {
        v1[0] = s2_idx;
        char_s2 = s2[s2_idx - 1];
        for (s1_idx = 0; s1_idx < s1_len; s1_idx++) {
            char_s1 = s1[s1_idx];
            cost = char_s1 == char_s2 ? 0 : 1;
            let m_min = v0[s1_idx + 1] + 1;
            let b = v1[s1_idx] + 1;
            let c = v0[s1_idx] + cost;
            if (b < m_min) {
                m_min = b;
            }
            if (c < m_min) {
                m_min = c;
            }
            v1[s1_idx + 1] = m_min;
        }
        let v_tmp = v0;
        v0 = v1;
        v1 = v_tmp;
    }
    return v0[s1_len];
}
function helper_similar_text_max(string, solutionsArray) {
    let maxPercent = 0;
    let bestMatch = solutionsArray[0];
    let bestMatchIndex = 0;
    for (let i = 0; i < solutionsArray.length; i = i + 1) {
        const nowPercent = similar_text(string, solutionsArray[i]);
        if (nowPercent > maxPercent) {
            maxPercent = nowPercent;
            bestMatch = solutionsArray[i];
            bestMatchIndex = i;
        }
    }
    return { accuracy: maxPercent, index: bestMatchIndex, word: bestMatch };
}
export function helper_capitaliseFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
